<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3">
          <!-- Profile Image -->
          <div class="card card-primary card-outline">
            <div class="card-body box-profile">
              <div class="text-center">
                <img
                  class="profile-user-img img-fluid img-circle"
                  :src=" $store.state.user.url_image || '../../static/dist/img/avatar04.png'"
                  alt="User profile picture"
                />
              </div>

              <h3 class="profile-username text-center">{{ $store.state.user.username }}</h3>

              <p class="text-muted text-center">ตำแหน่ง: {{ $store.state.user.role_name }}</p>

              <button class="btn btn-success btn-block btn-sm">
                <i class="fas fa-image"></i> อัพโหลดโปร์ไฟล์</button>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
        <div class="col-md-9">
          <div class="card card-primary card-outline">
            <!-- /.card-header -->
            <div class="card-body">
              <div
                class="tab-pane"
                id="settings"
              >
                <form
                  class="form-horizontal"
                  @submit.prevent="validatePass"
                >
                  <div class="form-group row">
                    <label
                      for="inputName2"
                      class="col-sm-2 col-form-label"
                    >Fullname</label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="Fullname"
                        placeholder="Fullname"
                        v-model="$store.state.user.name"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="tel"
                      class="col-sm-2 col-form-label"
                    >Telephone</label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="tel"
                        placeholder="telephone"
                        maxlength="15"
                        v-model="$store.state.user.telephone"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="New_Password"
                      class="col-sm-2 col-form-label"
                    >New Password</label>
                    <div class="col-sm-10">
                      <input
                        type="password"
                        class="form-control"
                        id="New_Password"
                        placeholder="New Password"
                        v-model="$store.state.user.password"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="offset-sm-2 col-sm-10">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm"
                      ><i class="far fa-save"></i> บันทึก</button>
                    </div>
                  </div>
                </form>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- /.card-body -->
          <!-- /.nav-tabs-custom -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </section>
</template>

<script>
import api from '../services/service'

export default {
  data () {
    return {
      Confirm_pass: '',
      header: {
        headers: {
          'Access-Token': this.$store.state.token
        }
      }
    }
  },
  methods: {
    getProfileUser () {
      this.$store.commit('Loading')
      api.userDetail(
        sessionStorage.Url,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            sessionStorage.user = JSON.stringify(result.data)
            this.$store.state.user = result.data
            this.Confirm_pass = ''
          } else {
            this.alert_msg('warning', 'เข้าสู่ระบบ', result.message)
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    validatePass () {
      if (this.$store.state.user.password !== '') {
        this.updateProfile()
      } else {
        this.alert_msg(
          'warning',
          'แจ้งเตือนระบบ',
          'กรุณากรอกข้อมูลให้ครบถ้วน'
        )
      }
    },
    updateProfile () {
      this.$store.commit('Loading')
      api.userUpdate(
        sessionStorage.Url,
        this.header,
        this.$store.state.user,
        result => {
          if (result.response === 'success') {
            this.alert_msg(
              'success',
              'แก้ไขข้อมูล Profile',
              'แก้ไขข้อมูลผู้ใช้งานเรียบร้อย'
            )
            this.getProfileUser()
          } else {
            this.alert_msg(
              'warning',
              'แก้ไขข้อมูล Profile',
              result.message
            )
          }
          this.$store.commit('Loading')
        },
        error => {
          this.alert_msg(
            'error',
            'แก้ไขข้อมูล Profile',
            'ไม่สามารถแก้ไขข้อมูล Profile ได้ เนื่องจาก ' + JSON.stringify(error)
          )
          console.log(JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    }
  },
  created () {
    this.getProfileUser()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Profile.vue